import React, {useRef, useState} from 'react';
import DataTable from '../DataTable';
import styles from './styles';
import {SearchBar, ModalContainer, InOutAnimation as Animation, Icons} from '@xpertdox_js/xdcomponents';
import {panel as panelStyles} from '@xpertdox_js/xdstyle'
import axios from 'axios'
import axiosConfig from '../../config/axios.config'
import Filters from './filter.js'
import EmailBroadcast from './EmailBroadcast'
import BroadcastButton from './BroadcastButton';
import {slideDown, slideUp} from '../preBuiltAnimations';
import {InstanceContext} from '../../InstanceContext';
import {UserContext} from '../../Context/UserContext';
import {FiltersContext} from '../../Context/FiltersContext';
import {ResponsiveContext} from '../../Context/ResponsiveContext';
import { trackActivity, trackError } from '../../utils/activityTracker'

const SearchTable = props => {
  const {tableSettings, dataTableSettings} = props
  const fetchingSearch = useRef(false);
  const filtersHit = useRef(false);
  const mutations = useRef(0);
  const [mutationMemo, setMutationMemo] = useState(null);
  const [data, setData] = useState(null)
  const [context, setContext] = useState(false)
  const [refreshing, setRefreshing] = useState(false)
  const {contextInstance} = React.useContext(InstanceContext);
  const { user, userAction } = React.useContext(UserContext);
  const [assets, setAssets] = useState([]);
  const {filters, filterAction} = React.useContext(FiltersContext);
  const onDiv = useRef(false)
  const [query, setQuery] = useState({
    conditions: [],
    filters: {}
  })
  const {responsiveSize} = React.useContext(ResponsiveContext);

  let params = props.match.params;
  let routeState = props.location.state || {};

  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const handleQueryChange = (newQuery) => {
    setQuery(newQuery);
    mutations.current++;
    setData(null);
  }

  const addConditions = term => {
    let newQuery = {...query}
    let found = newQuery.conditions.find(c => c.key_id === term.key_id)
    if(!found) {
      newQuery.conditions.push(term);
      handleQueryChange(newQuery)
    }
  }

  const removeTerm = (e,term) => {
    handleActivityLogUpdate(`SearchTable.removeTerm.(${term ? term : null })`)
    let newQuery = {...query}
    let i;
    let found = newQuery.conditions.find((c,index) => {
      i = index
      return c.key_id === term.key_id;
    })
    if(found) {
      newQuery.conditions.splice(i, 1)
      handleQueryChange(newQuery)
    }
  }

  // check mutation count vs last mutation count and update if needed
  if (data && mutationMemo !== mutations.current) {
    setRefreshing(false);
    setMutationMemo(mutations.current);
  }

  const instance = contextInstance || user.instance;

  const search = newQuery => {
    if (!fetchingSearch.current) {
      fetchingSearch.current = true;
      let body = newQuery ? newQuery : query;
      // if (body.conditions.length || Object.keys(body.filters).length)
      setRefreshing(true);
      filterAction({type:'setFilters', query:{conditions: body.conditions, ...body.filters}})
      // removed 'axiosConfig.auth' as token is updated on login
      axios.post(`${axiosConfig.apiUrl}/rt/search-table/${instance}/${user.email}`, body).then(res =>{
        fetchingSearch.current = false;
        mutations.current++;
        if (res.data) setData(res.data.filter(obj => obj.email))
      }).catch((err) => {
        console.log(err)
        trackError({ error: err, history: props.history })
        if (err && err.response && err.response.status === 403) {
          userAction({type: 'logout'})
        }
      })
    }
  }

  const filterHandle = (e, label) => {
    console.log(e, label)
    let filters = query.filters;
    if(['mutationsIN','mutationsOUT','pscore'].includes(label)) {
      let valueArr = e && e.length !== 0 ? [...new Set(e.map(v => v.value))] : null;
      filters = {
        ...filters,
        [label]: valueArr
      }
    } else {
      filters = {
        ...filters,
        [label]: e ? e.value : null
      }
    }
    let newQuery = {
      ...query,
      filters
    }
    setQuery(newQuery)
    search(newQuery)
  }

  // initial fetch
  if (data === null && !fetchingSearch.current && !filtersHit.current) search();

  if(data === null && props.location.state && props.location.state.query && !context) {
    setQuery(props.location.state.query)
    setContext(true)
  } else if (data === null && context) search()

  const customComp = React.useMemo(() => (props2) => <Animation
      condition={!props.broadcasting}
      alwaysRender
      animation={{in: slideUp, out: slideDown}}
      wrapStyles={{
        position: 'fixed',
        top: 'auto',
        bottom: '60px',
        right: '45px',
        zIndex: 1000
      }}
    >
    <BroadcastButton {...props2} />
  </Animation>, [props.broadcasting]);

  let instanceXt = contextInstance || user.instance;

  return (
    <React.Fragment>
      <div style={panelStyles} >
        <SearchBar
          axiosConfig={axiosConfig}
          placeholder='Select conditions'
          index={instanceXt.toLowerCase()}
          type='diseases'
          onDiv={onDiv}
          context={{instance: instanceXt}}
          selected={addConditions}
        />
        {query.conditions.length !== 0 &&
          <div style={styles.termsContainer}>
            {query.conditions.map((term, index) => {
              return <p style={styles.term} key={index}>
                {term.keyword} <Icons icon='times' onClick={e => removeTerm(e,term)} style={styles.icon}/>
              </p>
            })}
          </div>
        }
        <Filters data={query} handleSelect={filterHandle} />
      </div>
      <DataTable
        customComponents={data ? [{
            comp: customComp,
            params: 'test',
            props: {
              memo: props.broadcasting,
            },
            settings: {
              passController: true,
            },
            location: 'bottom',
          }
        ] : null}
        data={data}
        modal={tableSettings.modal}
        memo={params.type + mutationMemo}
        headers={tableSettings.headers || null}
        settings={dataTableSettings}
        cellRoute={tableSettings.route}
        history={props.history}
        location={props.location}
        cellRouteSettings={tableSettings.routeState}
        routeSettings={{
          auth: routeState.auth,
          instance: contextInstance || user.instance,
          prevState: props.location.state,
          searchTableContext: query
        }}
        spreadActions={props.groupActions}
        tabSettings={tableSettings}
        activeFetchParam={null}
        refreshing={refreshing}
        options={{
          customTopOffset: '45px',
          offsetWidth: 175,
        }}
      />
      <ModalContainer
        wrapStyles={styles.wrapStyle}
        width={responsiveSize === 'mobile'
          ? document.body.clientWidth * .85 + 'px'
          : document.body.clientWidth * .4 + 'px'
        }
        open={props.broadcasting}
        close={() => props.setBroadcasting(false)}
        showOverlay={props.broadcasting}
      >
        <EmailBroadcast
          data={props.broadcasting}
          setBroadcasting={props.setBroadcasting}
          broadcasting={props.broadcasting}
          email={user.email}
          instance={props.instance || user.instance}
          assets={assets}
          setAssets={setAssets}
        />
      </ModalContainer>
    </React.Fragment>
  )
}

export default SearchTable;
